export default{
    pleaseCompleteSecurityVerification: "请完成安全验证",
    slideToTheRightToValidation: "向右滑动以完成验证",
    verificationSuccessful: "验证成功",
    verificationFailed: "验证失败",
}